export const storageTitles = {
  ROLES: 'roles'
};
